function users(state ={}, action) {
    switch (action.type) {
      case 'AUTH':
        return action.something
      default:
        return state
    }
  }

export default users